import { ISpringEntity, SpringRestApi } from "@oceanjs/core";


export class PCSpringRestApi<TEntity extends ISpringEntity> extends SpringRestApi<TEntity> {

  constructor(resource: string) {
    super(resource);
  }

  public static getApi<T extends ISpringEntity>(entity: string): PCSpringRestApi<T> {
    return new PCSpringRestApi<T>(entity);
  }
}
